import styles from '@modules/ui/shared/utils/styles';
import { makeStyles } from '@rbx/ui';

const useOperationSummaryStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    [theme.breakpoints.down('Medium')]: {
      flexDirection: 'column',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  summaryAndStability: {
    display: 'inline',
    // Prevents summary and stability from overlapping with accordion chevron dropdown
    paddingRight: '16px',
    [theme.breakpoints.down('Medium')]: {
      paddingRight: 0,
    },
  },
  summary: {
    '& .MuiTypography-root': {
      ...theme.typography.largeLabel1,
      color: theme.palette.content.standard,
      display: 'inline',
      margin: 0,
      fontWeight: '500',
      paddingRight: '12px',
    },
  },
  pathWrapper: {
    display: 'inline',
  },
  path: {
    ...styles.wordBreakWrap,
    color: theme.palette.content.muted,
    cursor: 'copy',
  },
  domainAndTags: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  tags: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
}));

export default useOperationSummaryStyles;
